var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect } from 'react';
export default function useAPI(action, deps, runAfter) {
    var _a = __read(useState(), 2), error = _a[0], setError = _a[1];
    var _b = __read(useState(), 2), result = _b[0], setResult = _b[1];
    var _c = __read(useState('success'), 2), status = _c[0], setStatus = _c[1];
    var _d = __read(useState(false), 2), cancelled = _d[0], setCancelled = _d[1];
    useEffect(function () {
        if (!action)
            return;
        setResult(undefined);
        setError(undefined);
        setStatus('loading');
        setCancelled(false);
        action()
            .then(function (result) {
            if (cancelled)
                return;
            setResult(result);
            setStatus('success');
        })
            .catch(function (e) {
            if (cancelled)
                return;
            setError(e);
            setStatus('error');
        });
        return function () { };
    }, __spreadArray(__spreadArray([], __read((deps || [])), false), [cancelled], false));
    useEffect(function () {
        if ((status === 'success' || status === 'error') && !cancelled && typeof runAfter === 'function') {
            runAfter({
                error: error,
                result: result,
                status: status
            });
        }
    }, [status, result]);
    return {
        error: error,
        result: result,
        status: status
    };
}
//# sourceMappingURL=useAPI.js.map